import { useContext } from "react";

import { BloombergEpisodesPageContext } from "./BloombergEpisodesPageContext";

export const useBloombergEpisodesPageContext = () => {
  const context = useContext(BloombergEpisodesPageContext);

  return context;
};
